<ng-container *ngIf="result?.videoData">
  <div class="col-12 px-2 pl-md-3 position-static"
       data-cy="mb-search-family-line-name"
       [ngClass]="[result?.videoData?.description?.length ? 'mt-1' : 'mt-0']"
  >
    <div class="cursor-pointer pb-3 pb-md-0">
      <mb-link [linkData]="{uid:'special'}"
               [queryParams]="{ currentVideoId: result?.videoData.id }"
               [routerLink]="videoLibraryUrl"
               [styleClass]="['result-item', 'result-item-video']"
               [useSlot]="true"
               target="_self"
      >
        <strong [innerHTML]="result.videoData.title | safeHtml"></strong>
      </mb-link>
      <strong [innerHTML]="duration"
              class="duration"
      ></strong>
      <span *ngIf="result?.contentType?.length"
            class="content-type"
            [innerHTML]="result?.contentType | safeHtml"
      ></span>
    </div>
    <p class="content-excerpt"
       *ngIf="result.videoData.description?.length"
       [innerHTML]="result.videoData.description | safeHtml"
    ></p>
  </div>
</ng-container>